import { styled } from "@mui/material";

export const InlineForm = styled("form")({
  display: "flex",
  flexDirection: "row",

  // TODO: refactor to use nth child?
  ".MuiInputBase-root": {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  ".MuiButton-root": {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    height: "42px",
    marginTop: "24px",
  },
});
